import React from 'react';
import Common from "./Common";
import home from "../image/home.svg";

const Home = () =>{
    return(
        <>
            <Common
                name="Grow your business with"
                imgsrc={home}
                btnName="Get Started"
                btnLink="/service"
            />
        </>
    )
}

export default Home;